/* Session-scoped progressive enhancement. The server's first three remain on failure. */
(() => {
  if (customElements.get('hf-set-bundle')) return;
  customElements.define('hf-set-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized || this.dataset.designMode === 'true') return;
      const templates = [...this.querySelectorAll('template[data-bundle-id]')];
      const target = this.querySelector('[data-bundle-display]');
      if (!target || !templates.length) return;
      try {
        const candidates = new Map(templates.map(t => [t.dataset.bundleId, t]));
        const count = Math.min(3, candidates.size);
        const key = `hfSetBundleSelection:${this.dataset.sectionId}`;
        let stored = [];
        try { stored = JSON.parse(sessionStorage.getItem(key) || '[]'); } catch (_) { /* unavailable or corrupt */ }
        const selected = Array.isArray(stored)
          ? [...new Set(stored.filter(id => typeof id === 'string' && candidates.has(id)))].slice(0, count)
          : [];
        const remaining = [...candidates.keys()].filter(id => !selected.includes(id));
        for (let i = remaining.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [remaining[i], remaining[j]] = [remaining[j], remaining[i]];
        }
        selected.push(...remaining.slice(0, count - selected.length));
        const fragment = document.createDocumentFragment();
        selected.forEach((id, index) => {
          const card = candidates.get(id).content.firstElementChild.cloneNode(true);
          card.classList.toggle('hf-tp-set--lead', index === 0);
          card.classList.toggle('hf-tp-set--mini', index !== 0);
          const image = card.querySelector('.hf-tp-set__media img');
          if (image) image.sizes = index === 0
            ? '(min-width: 1280px) 510px, (min-width: 768px) 44vw, calc(100vw - 40px)'
            : '(min-width: 1280px) 240px, (min-width: 768px) 20vw, calc(50vw - 26px)';
          fragment.append(card);
        });
        // Commit only after a complete, valid selection exists; DOM and reading order agree.
        target.replaceChildren(fragment);
        this.dataset.initialized = 'true';
        try { sessionStorage.setItem(key, JSON.stringify(selected)); } catch (_) { /* random still works */ }
      } catch (_) { /* Keep usable Liquid fallback if enhancement fails. */ }
    }
  });
})();
